import { Component, ElementRef, HostListener, Input, OnInit, output } from '@angular/core';
import { ISearchParams, IShopCart } from 'core-lib';
import { ButtonModule } from 'primeng/button';
import { ShopcartService } from 'core-lib';
import { TranslateModule } from '@ngx-translate/core';
import { AvailabilityService } from 'core-lib';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { SettingsService } from 'core-lib';
import { DisplayPricePipe } from '../../pipes/displayPrice';
import { formatRateNamePipe } from '../../pipes/format-rate-name.pipe';

@Component({
    selector: 'app-multiroom-navigator',
    imports: [ButtonModule, DisplayPricePipe, TranslateModule, formatRateNamePipe],
    templateUrl: './multiroom-navigator.component.html',
    styleUrl: './multiroom-navigator.component.scss',
    animations: [
        fadeInOnEnterAnimation({ duration: 600 }),
        fadeOutOnLeaveAnimation({ duration: 600 })
    ]
})
export class MultiroomNavigatorComponent implements OnInit {

  screenWidth:any = window.innerWidth;

  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    let width = event.target.innerWidth
    this.screenWidth = width;
    if (width > 992) {
      this.width = this.el.nativeElement.offsetWidth;

    }

  }

  @Input() searchParams: ISearchParams
  @Input() activeRoom: number
  changeRoomIndex:any = output();

  roomCount:number=0;
  rooms:any = [];

  shopcart:IShopCart;

  enableScrolling:boolean = false;
  navigatorClosed:boolean = false;  //also handled in availability.component.ts via viewchild
  width:number = 0;
  height:number = 0;
  allSelectedModalShown:boolean = false;
  daysDelta:number = 0;
  

  constructor(
    private el: ElementRef, 
    private shopCartService: ShopcartService, 
    private avService: AvailabilityService,
    public settings: SettingsService
  ) {
    
  }



  ngOnInit(): void {

    
    this.roomCount = this.searchParams?.roomData?.length || 0;
    this.searchParams?.roomData?.forEach(element => {
        this.rooms.push({
          adults: element.adults,
          children: element.children,
          selected: false,
        });
    });

    this.shopCartService.shopCart$.subscribe((cart:IShopCart|null) => {
      if (cart) {
        this.shopcart = cart;
      }
    });

    this.daysDelta = this.avService.getSearchDaysDelta();

  }


  ngAfterContentInit() {
    if (this.screenWidth && this.screenWidth > 992) {
      this.width = this.el.nativeElement.offsetWidth;

      setTimeout(() => {
        this.height = this.el.nativeElement.children[0].children[0].offsetHeight;
      },200);
    }
    
    
  } 

  calculatePricePerNight(price:any) {
    price = parseInt(price);

    return price/this.daysDelta;
  }

  onWindowScroll($event:any) {
    if (this.screenWidth && this.screenWidth > 992) {
      if (this.el.nativeElement.getBoundingClientRect().top < 0) {
        this.enableScrolling = true;
      }
      else {
        this.enableScrolling = false;
      }
    }
  }

  toggleNavigatorOpen() {
    this.navigatorClosed = !this.navigatorClosed;
  }

  goToProfile() {
    this.avService.multiRoomContinue();
    document.querySelector('body')?.classList.remove('modal-is-open');
  }

  roomSelected(roomIndex:number) {
    if (this.shopcart.items.length >= this.roomCount) {
      this.allSelectedModalShown = true;
      document.querySelector('body')?.classList.add('modal-is-open');
    }
  }

  changeRoom(index:number) {
    this.allSelectedModalShown = false;
    document.querySelector('body')?.classList.remove('modal-is-open');
    this.changeRoomIndex.emit(index);
  }

  setActiveRoom(roomIndex:number) {
    if(this.shopcart?.items[roomIndex] || this.shopcart?.items[roomIndex-1]) {
      this.changeRoomIndex.emit(roomIndex);
    }
  }
}
